import {Schema, useUrlFilters} from '../useUrlFilters';
import {SelectedInputGroup} from './types/filters.type';

export interface ShopListingFilters {
  search: string;
  input_guid: SelectedInputGroup[];
  order_by: string;
  in_person_possibility: boolean;
  has_delivery: boolean;
  has_guarantee: boolean;
  has_discount: boolean;
  start_price?: number;
  end_price?: number;
}

const defaultSchema: Schema<ShopListingFilters> = {
  search: {type: 'string', default: ''},
  input_guid: {type: 'json', default: []},
  order_by: {type: 'string', default: ''},
  in_person_possibility: {type: 'boolean', default: false},
  has_delivery: {type: 'boolean', default: false},
  has_guarantee: {type: 'boolean', default: false},
  has_discount: {type: 'boolean', default: false},
  start_price: {type: 'number', default: undefined},
  end_price: {type: 'number', default: undefined},
};

export function useShopListingFilters() {
  const {values, setFilter, setFilters, resetFilter, reset} =
    useUrlFilters<ShopListingFilters>(defaultSchema);

  return {
    shopListingFilter: values,
    setShopListingFilter: setFilter,
    setShopListingFilters: setFilters,
    resetFilterShopListing: resetFilter,
    resetShopListing: reset,
  };
}
